import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * PD-14263 (Phase 4) — a note on a port-in request, written by Workd-internal
 * support from the port-ops console. Internal by default; `isCustomerVisible`
 * surfaces it in the tenant CRM too (e.g. "we've flagged this; check your
 * email").
 *
 * Lives in the TENANT DB alongside `port_in_request` (the tenant IS the
 * instance, so there is no instance FK). `fk_user__id_author` is a Workd user
 * (the note is authored cross-tenant from the config app, server-to-server, so
 * it is nullable — a system/automation note has no author). BaseEntity carries
 * the audit trail.
 */
@Index('port_in_request_note_request_idx', ['fkPortInRequestId'])
@Entity('port_in_request_note')
export class PortInRequestNoteEntity extends BaseEntity {
	@Column('int', { name: 'fk_port_in_request__id', unsigned: true })
	public fkPortInRequestId!: number;

	@Column('int', { name: 'fk_user__id_author', unsigned: true, nullable: true })
	public fkUserIdAuthor!: number | null;

	@Column('text', { name: 'body' })
	public body!: string;

	// `type: 'boolean'` (not raw `'tinyint'`) so TypeORM's mysql driver
	// transforms the tinyint(1) value back to a real boolean on read — a raw
	// `tinyint` column reads as the number 1/0, which then fails a `=== true`
	// check in the DTO mapping. Stored DDL is identical (tinyint(1)).
	@Column({ name: 'isCustomerVisible', type: 'boolean', default: false })
	public isCustomerVisible!: boolean;
}
